import { ROUTES } from '../../routing';
import TeamsProfileOnboarding from '../../pages/Onboarding/TeamsProfileOnboarding';
import TeamsCohortOnboarding from '../../pages/Onboarding/TeamsCohortOnboarding';
import TeamDashboard from '../../pages/Dashboard/TeamsDashboard';
import TeamActivity from '../../pages/Activity/TeamsActivity';
import TeamsProject from '../../pages/Project/TeamsProject';
import TeamsProjectsDashboard from '../../pages/ProjectsDashboard/TeamsProjectsDashboard';
import AssessmentTest from '../../pages/AssessmentTest';
import CompanyProjectCheckIn1 from '../../pages/CompanyProject/CheckIn1';
import CompanyProjectCheckIn2 from '../../pages/CompanyProject/CheckIn2';
import CompanyProjectSubmit from '../../pages/CompanyProject/ProjectUpload';
import CohortFeedback from '../../pages/CohortFeedback';
import AuthenticatedRoute from '../../components/Routes/AuthenticatedRoute';

const TeamRoute = AuthenticatedRoute;

export const TEAM_ROUTES = [
  <TeamRoute
    exact
    path={ROUTES.TEAMS.PROFILE_ONBOARDING.PATH}
    key={ROUTES.TEAMS.PROFILE_ONBOARDING.PATH}
  >
    <TeamsProfileOnboarding />
  </TeamRoute>,
  <TeamRoute
    exact
    path={ROUTES.TEAMS.COHORT_ONBOARDING.PATH}
    key={ROUTES.TEAMS.COHORT_ONBOARDING.PATH}
  >
    <TeamsCohortOnboarding />
  </TeamRoute>,
  <TeamRoute
    exact
    path={ROUTES.TEAMS.MODULE_DASHBOARD.PATH}
    key={ROUTES.TEAMS.MODULE_DASHBOARD.PATH}
  >
    <TeamDashboard />
  </TeamRoute>,
  <TeamRoute
    exact
    path={ROUTES.TEAMS.ACTIVITY.PATH}
    key={ROUTES.TEAMS.ACTIVITY.PATH}
  >
    <TeamActivity />
  </TeamRoute>,
  <TeamRoute
    exact
    path={ROUTES.TEAMS.PROJECT.PATH}
    key={ROUTES.TEAMS.PROJECT.PATH}
  >
    <TeamsProject />
  </TeamRoute>,
  <TeamRoute
    exact
    path={ROUTES.TEAMS.PROJECTS_DASHBOARD.PATH}
    key={ROUTES.TEAMS.PROJECTS_DASHBOARD.PATH}
  >
    <TeamsProjectsDashboard />
  </TeamRoute>,
  <TeamRoute
    exact
    path={ROUTES.TEAMS.ASSESSMENT_TEST.PATH}
    key={ROUTES.TEAMS.ASSESSMENT_TEST.PATH}
  >
    <AssessmentTest />
  </TeamRoute>,
  <TeamRoute
    exact
    path={ROUTES.TEAMS.COMPANY_PROJECT_CHECKIN_1.PATH}
    key={ROUTES.TEAMS.COMPANY_PROJECT_CHECKIN_1.PATH}
  >
    <CompanyProjectCheckIn1 />
  </TeamRoute>,
  <TeamRoute
    exact
    path={ROUTES.TEAMS.COMPANY_PROJECT_CHECKIN_2.PATH}
    key={ROUTES.TEAMS.COMPANY_PROJECT_CHECKIN_2.PATH}
  >
    <CompanyProjectCheckIn2 />
  </TeamRoute>,
  <TeamRoute
    exact
    path={ROUTES.TEAMS.COMPANY_PROJECT_SUBMIT.PATH}
    key={ROUTES.TEAMS.COMPANY_PROJECT_SUBMIT.PATH}
  >
    <CompanyProjectSubmit />
  </TeamRoute>,
  <TeamRoute
    exact
    path={ROUTES.TEAMS.COHORT_FEEDBACK.PATH}
    key={ROUTES.TEAMS.COHORT_FEEDBACK.PATH}
  >
    <CohortFeedback />
  </TeamRoute>,
];
